/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminDeleteInviteOptions, AdminDeleteInviteResponses } from '../../models/AdminDeleteInvite'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Delete Invite
 * {@link /admin/org/:org_id/invite/:invite_id}
 */
export function adminDeleteInvite<ThrowOnError extends boolean = true>(options: Options<AdminDeleteInviteOptions, ThrowOnError>): Promise<UnwrappedResult<AdminDeleteInviteResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'DELETE', url: '/admin/org/{org_id}/invite/{invite_id}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminDeleteInviteResponses, ThrowOnError>>
}
